import {
  newTagConverter as _newTagConverter,
  tagConverter as _tagConverter,
} from '@griply/services';
import { Tag } from '@griply/types';
import { FirestoreDataConverter } from 'firebase/firestore';

export const tagConverter =
  _tagConverter as unknown as FirestoreDataConverter<Tag>;

export const newTagConverter = _newTagConverter;
